import { render, staticRenderFns } from "./CheckboxFormItem.vue?vue&type=template&id=55c24a24&scoped=true&"
import script from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxFormItem.vue?vue&type=style&index=0&id=55c24a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c24a24",
  null
  
)

export default component.exports